export enum EssentialsReadingSkillSlug {
  whatTheTextSays = "essentials-reading-skills-what-the-text-says",
  mainIdea = "essentials-reading-skills-main-idea",
  keyDetails = "essentials-reading-skills-key-details",
  summarization = "essentials-reading-skills-summarization",
  connectingPeopleEventsIdeas = "essentials-reading-skills-connecting-people-events-ideas",
  wordMeaningChoice = "essentials-reading-skills-word-meaning-choice",
  textStructure = "essentials-reading-skills-text-structure",
  pointOfViewPurpose = "essentials-reading-skills-point-of-view-purpose",
  interpretMultimedia = "essentials-reading-skills-interpret-multimedia",
  argumentsClaims = "essentials-reading-skills-arguments-claims",
  theme = "essentials-reading-skills-theme",
}

export interface StandardCategory {
  content_id: string;
  slug: EssentialsReadingSkillSlug | string;
  text: string;
}
